<template>
  <v-container fluid>
    <v-row justify="center" align="center">
      <v-col cols="12" align="right">
        <v-btn color="primary" align="right" @click="openDialog"> Thêm </v-btn>
      </v-col>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="config_menu_left"
          :items-per-page="10"
          class="elevation-1"
        >
          <template v-slot:item.is_hidden="{ item }">
            <v-checkbox
              :input-value="!item.is_hidden"
              @change="updateMenuHidden(item.id)"
            ></v-checkbox>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editItem(item.id)">
              mdi-pencil
            </v-icon>
            <v-icon small @click="deleteItem(item.id)"> mdi-delete </v-icon>
          </template>
        </v-data-table>
      </v-col>

      <!--      dialog-->
      <v-dialog v-model="dialog" persistent max-width="600">
        <v-card class="rounded-lg">
          <v-card-title class="d-flex justify-center">
            Thêm menu
          </v-card-title>
          <v-card-text>
            <v-col>
              <v-text-field
                type="text"
                background-color="#EDF2F7"
                filled
                v-model="name"
                placeholder="Tên menu"
                label="Tên"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-autocomplete
                  background-color="#EDF2F7"
                  filled
                  item-value="id"
                  item-text="name"
                  :items="list_config_menu_left"
                  v-model="parent_id"
                  label="Menu cha"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12">
                <v-select
                background-color="#EDF2F7"
                filled
                v-model="is_hidden"
                item-text="text"
                item-value="id"
                :items="list_hidden"
                label="Chọn"
                ></v-select>
            </v-col>
            <v-col cols="12">
                <v-select
                background-color="#EDF2F7"
                filled
                item-text="text"
                v-model="type"
                :items="types"
                item-value="id"
                label="Chọn loại Link"
                ></v-select>
            </v-col>
            <v-col cols="12" v-show="type == 2">
                <v-text-field
                background-color="#EDF2F7"
                filled
                v-model="link.url"
                item-text="name"
                item-value="id"
                label="Nhập đường dẫn"
                ></v-text-field>
            </v-col>
            <v-col cols="12" v-show="type == 1">
                <v-select
                background-color="#EDF2F7"
                filled
                item-text="name"
                v-model="link.type"
                :items="modlues"
                item-value="id"
                label="Chọn loại"
                ></v-select>
            </v-col>
            <v-col cols="12" v-show="type == 1">
                <v-autocomplete
                background-color="#EDF2F7"
                filled
                v-model="link.object_id"
                item-text="name"
                item-value="slug"
                :items="list_ids"
                label="Chọn ID"
                ></v-autocomplete>
            </v-col>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialog = false"> Hủy </v-btn>
            <v-btn v-if="is_edit" color="primary" text @click="update">
              Lưu
            </v-btn>
            <v-btn v-else color="primary" text @click="addNew"> Lưu </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import { GET_LIST_CATEGORY } from "@/store/modules/category";
import { GET_LIST_BRAND } from "@/store/modules/brand";
import { GET_LIST_TAG } from "@/store/modules/tag";
import {
  GET_DETAIL_CONFIG_MENU_LEFT,
  GET_CONFIG_MENU_LEFT,
  DELETE_CONFIG_MENU_LEFT,
  SAVE_CONFIG_MENU_LEFT,
  UPDATE_CONFIG_MENU_LEFT,
  UPDATE_CONFIG_MENU_LEFT_HIDDEN,
  SET_DETAIL_CONFIG_MENU_LEFT
} from "@/store/modules/configs";
export default {
  data() {
    return {
        name: null,
        parent_id: null,
        is_hidden: 0,
        list_hidden: [
          {id:0, text: "Hiển thị"},
          {id:1, text: "Không Hiển thị"}
        ],
        type: null,
        link: {
            brand_slug: null,
            type: null,
            object_id: null,
            url: null   
        },
        headers: [
            { text: "Tên", value: "name" },
            { text: "Hiển thị", value: "is_hidden" },
            { text: 'Actions', value: 'actions' }
        ],
        dialog: false,
        url: "",
        is_edit: false,
        types: [
            {
                id: 1,
                text: "Link theo loại",
            },
            {
                id: 2,
                text: "Link theo URL",
            },
        ],
        modlues: [
            {
                id: "category",
                name: "category",
            },
            {
                id: "brand",
                name: "brand",
            },
            {
                id: "tag",
                name: "tag",
            },
        ],
        list_ids: [],
        list_config_menu_left: [],
    };
  },


  watch: {
    config_menu_left(val){
        this.list_config_menu_left = val
    },
    detail_menu_left(val) {
        if (val) {
            let exceptId = val.id ? [val.id] : [];
            this.name = val.name;
            this.parent_id = val.parent_id;
            this.is_hidden = val.is_hidden ?? 0;
            this.type = val.type;
            this.link = {
                type: val.link.type ?? null,
                object_id: val.link.object_id ?? null,
                url: val.link.url ?? null
            };
            this.list_config_menu_left = this.config_menu_left.filter(
                (item) => {
                    if(exceptId.includes(item.id) || exceptId.includes(item.parent_id)){
                        exceptId.push(item.id);
                        return false;
                    }
                    return true;
                }
            );
        }
    },
    type(value){
      if(value == 1){
        this.link.url = null;
      }
      if(value == 2){
        this.link.brand_slug = null;
        this.link.type = null;
        this.link.object_id = null;
      }
    },
    ['link.type'](value){
      this.setListByType(value);
    },
  },
  computed: {
    ...mapGetters({
      config_menu_left: "config_menu_left",
      detail_menu_left: "detail_menu_left"
    })
  },
  async created() {
    await this.$store.dispatch(`${GET_CONFIG_MENU_LEFT}`);
  },
  methods: {
    async addNew() {
        const _this = this;
        this.updateLink();
        let form_menu = {
            name : this.name,
            parent_id : this.parent_id,
            is_hidden : this.is_hidden,
            type: this.type,
            link : this.link
        }
        await _this.$store.dispatch(`${SAVE_CONFIG_MENU_LEFT}`, form_menu).then((data) => {
        if (data.status===1) {
          this.$toasted.success('Thêm mới thành công!', {
            duration:1000,
            position:'top-center'
          })
          _this.$store.dispatch(`${GET_CONFIG_MENU_LEFT}`);
          this.dialog = false;
        }else{
            alert(data.errors);
        }
      });
    },
    async update() {
      this.updateLink();
      let form_promotion = {
        id: this.detail_menu_left.id,
        name: this.name,
        is_hidden: this.is_hidden,
        parent_id : this.parent_id,
        type : this.type,
        link : this.link
      };
      await this.$store
        .dispatch(`${UPDATE_CONFIG_MENU_LEFT}`, form_promotion)
        .then((data) => {
          if (data.status===1) {
            this.$toasted.success('Cập nhật thành công!', {
              duration:1000,
              position:'top-center'
            })
            this.$store.dispatch(`${GET_CONFIG_MENU_LEFT}`);
            this.dialog = false;
          }else{
            alert(data.errors);
          }
        });
    },
    async openDialog() {
        this.is_edit = false;
        this.$store.commit(`${SET_DETAIL_CONFIG_MENU_LEFT}`, {});
        this.name = null;
        this.is_hidden = 0;
        this.parent_id = null;
        this.type = null;
        this.link = {
            brand_slug: null,
            type: null,
            object_id: null,
            url: null   
        };
        this.dialog = true;
    },
    async editItem(id) {
      this.is_edit = true;
      this.$store.dispatch(`${GET_DETAIL_CONFIG_MENU_LEFT}`, id).then((data) => {
        if (data) {
          this.dialog = true;
        }
      });
    },
    async deleteItem(id) {
      const _this = this;
      confirm("Bạn có chắc muốn xóa?") &&
        (await this.$store.dispatch(`${DELETE_CONFIG_MENU_LEFT}`, id).then((data) => {
          if (data && data.status === 1) {
            _this.$store.dispatch(`${GET_CONFIG_MENU_LEFT}`);
          }else{
            alert(data.message);
          }
        }));
    },
    setListByType(value){
      const _this = this;
      let url = "";
      if(value == "category"){
        url = GET_LIST_CATEGORY;
      }
      if(value == "brand"){
        url = GET_LIST_BRAND;
      }
      if(value == "tag"){
        url = GET_LIST_TAG;
      }
      if (url != "") {
        this.$store.dispatch(url).then((data) => {
          if (data && data.data && data.data.length > 0) {
            _this.list_ids = data.data;
          } else {
            _this.list_ids = [];
          }
        });
      }
    },
    updateLink(){
      this.link.brand_slug = null;
      if(this.link.type == "category"){
        let category = this.list_ids.find(item =>{
          return item.slug == this.link.object_id
        })
        console.log(category);
        this.link.brand_slug = category.brand_slug;
      }
    },
    updateMenuHidden(id){
      this.$store.dispatch(UPDATE_CONFIG_MENU_LEFT_HIDDEN, {id: id});
    }
  },
};
</script>